var dateFormat = require('dateformat');

dateFormat.i18n = {
  dayNames: [
    'Paz', 'Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cmt',
    'Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'
  ],
  monthNames: [
    'Oca', 'Şub', 'Mrt', 'Nis', 'May', 'Haz', 'Tem', 'Agu', 'Eyl', 'Ekm', 'Kas', 'Ara',
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
  ],
  timeNames: [
    's', 'ö', 'ös', 'mm', 'S', 'Ö', 'ÖS', 'ÖÖ'
  ]
};

const datetr = (timestamp, format = 'dd.mm.yyyy') => {
  return dateFormat(new Date(timestamp), format);
};

export default datetr;